import { render, staticRenderFns } from "./images-wrapper.vue?vue&type=template&id=7a590606&scoped=true&"
import script from "./images-wrapper.vue?vue&type=script&lang=js&"
export * from "./images-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./images-wrapper.vue?vue&type=style&index=0&id=7a590606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a590606",
  null
  
)

export default component.exports